import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface CompanySizeSelectionProps {
  value: number | null;
  setValue: (value: number | null) => void;
}

interface CompanySizeRangeObject {
  min: number;
  max: number | null;
}

const companySizeRange: CompanySizeRangeObject[] = [
  {
    min: 1,
    max: 100,
  },
  {
    min: 101,
    max: 250,
  },
  {
    min: 251,
    max: 500,
  },
  {
    min: 501,
    max: 1000,
  },
  {
    min: 1001,
    max: null,
  },
];

const selectionBox = {
  padding: '16px',
  backgroundColor: '#F6F6F6',
  borderRadius: '6px',
  cursor: 'pointer',
};
const selectedBox = {
  padding: '16px',
  backgroundColor: '#EEFFFD',
  borderRadius: '6px',
  color: '#00CECF',
  cursor: 'pointer',
};

const checkIfBetween = (
  value: number | null,
  range: CompanySizeRangeObject,
) => {
  if (value === null) return false;
  if (value >= range.min && (range.max === null || value <= range.max))
    return true;
  return false;
};

const CompanySizeSelection = ({
  value,
  setValue,
}: CompanySizeSelectionProps) => {
  const setValuehandler = (newValue: number | null) => {
    if (newValue === null) setValue(10000);
    else setValue(newValue);
  };

  return (
    <Stack>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom: '12px',
        }}
      >
        <FormattedMessage
          defaultMessage='Company Size <span>(Employees)</span>'
          values={{
            span: (chunks) => (
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#878787',
                }}
              >
                {chunks}
              </span>
            ),
          }}
        />
      </Typography>
      <Stack direction='row' gap={2}>
        {companySizeRange.map((item, key) => (
          <Stack
            direction='row'
            gap={1}
            sx={checkIfBetween(value, item) ? selectedBox : selectionBox}
            key={key}
            onClick={() => setValuehandler(item.max)}
          >
            {checkIfBetween(value, item) && (
              <CheckCircleIcon sx={{ color: '#00CECF' }} />
            )}
            <Typography>
              {item.max !== null ? `${item.min}-${item.max}` : `${item.min}+`}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default CompanySizeSelection;
